import { FC } from "react";
import Row from "./Row";
import styles from "./Body.module.sass";
import { useAppSelector } from "toolkit/hooks";

const Body: FC = () => {
	const documents = useAppSelector((state) => state.viewDocuments.documents);

	return (
		<div data-comment-false={true} className={styles.body}>
			{documents && documents.map((row, index) => <Row row={row} index={index} key={index} />)}
		</div>
	);
};

export default Body;
